import { useEffect } from "react";
import { hasConsent } from "../../Utils/cookieConsent";

const PIXEL_ID = "640671461928034";
const PIXEL_SRC = "https://connect.facebook.net/en_US/fbevents.js";

// Meta's base code, loaded from an effect. It used to sit in a react-helmet
// <script> with a template-literal child, which Helmet renders as an empty
// tag, so the pixel never loaded and fbq was never defined.
//
// The pixel starts revoked unless marketing consent is already stored, so it
// sends nothing and sets no cookies until the visitor accepts. The banner
// then flips it with fbq('consent', 'grant') through applyConsent(); queued
// calls such as the PageView below are sent at that point.
export const loadMetaPixel = () => {
  if (typeof window === "undefined" || window.fbq) return;

  const fbq = function fbq() {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, arguments); // eslint-disable-line prefer-rest-params
    } else {
      fbq.queue.push(arguments); // eslint-disable-line prefer-rest-params
    }
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = PIXEL_SRC;
  const first = document.getElementsByTagName("script")[0];
  if (first && first.parentNode) {
    first.parentNode.insertBefore(script, first);
  } else {
    document.head.appendChild(script);
  }

  window.fbq("consent", hasConsent("marketing") ? "grant" : "revoke");
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
};

const MetaPixel = () => {
  useEffect(() => {
    loadMetaPixel();
  }, []);
  return null;
};

export default MetaPixel;
